export const SearchClear = () => {
    const searchInputs = document.querySelectorAll('.search-form__field');

    searchInputs.forEach((input) => {
        const clearButton = document.createElement('button');
        clearButton.className = 'search-form__clear-button clear-button';
        clearButton.type = 'button'; // prevents it from submitting a form if inside one
        clearButton.innerHTML = `
            <svg class="search-form__svg" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8704 0L6.6 5.2704L1.3296 0L0 1.3296L5.2704 6.6L0 11.8704L1.3296 13.2L6.6 7.9296L11.8704 13.2L13.2 11.8704L7.9296 6.6L13.2 1.3296L11.8704 0Z" fill="#001E3E"/>
            </svg>`;

        clearButton.style.display = 'none'; // Hide initially
        input.parentNode.appendChild(clearButton);

        input.addEventListener('input', function () {
            clearButton.style.display = this.value ? 'block' : 'none';
        });

        clearButton.addEventListener('click', function (event) {
            event.preventDefault();
            input.value = '';
            input.dispatchEvent(new Event('input')); // Trigger input event to hide button
        });
    });
}
